export const locales = {
    cardTitle: 'Bienvenue dans votre espace Amelipro',
    header: 'Retrouvez tous les services de l’Assurance Maladie réunis dans une seule offre',
    advantagesTitle: 'De nombreux avantages',
    advantages: {
        advantage1: 'Utilisation rapide et facile pour un gain de temps',
        advantage2: 'Démarche simplifées grâce aux référentiels',
        advantage3: 'Dématérialisation pour moins de papier',
        advantage4: 'Prise en compte immédiate par l’Assurance Maladie',
        advantage5: 'De plus en plus de régimes d Assurance Maladie',
        advantage6: 'Démarches sécurisées et simplifiées pour vos patients'
    },
    servicesTitle: 'Des services d’aide au suivi de votre activité accessibles où que vous soyez.',
    services: {
        service1: {
            title: 'Tous mes paiements',
            icon:'paiements',
            text: 'Consultez vos tiers-payant (factures, lots), vos relevés mensuels, vos forfaits et vos indus, pour les principaux régimes d’Assurance Maladie.'
        },
        service2: {
            title: 'Ma convention',
            icon: 'convention',
            text: 'Suivez vos indicateurs de la ROSP, réalisez vos déclarations et consultez le détail de vos rémunérations.'
        },
        service3: {
            title: 'Info Patient',
            icon: 'patientele',
            text: 'Consultez les droits de base à l’Assurance Maladie de vos patients.'
        },
        service4: {
            title: 'Commandes',
            icon: 'commandes',
            text: 'Commandez des formulaires Cerfa, des kits de dépistage du cancer colorectal, des tests de diagnostic rapide de l’angine ou des tensiomètres.'
        }
    },
    onlineProcessTitle: 'Des téléprocédures pour faciliter la prise en charge de vos patients.',
    onlineProcessSubtitle: 'Accessible par authentification avec la carte CPS',
    onlineProcess: {
        process1: 'Arret de travail',
        process2: `Accident du travail
        Maladies professionnelles`,
        process3: `Protocole de soins
        Affections de longue durée`,
        process4: 'Prescription de transport',
        process5: 'Déclaration médecin traitant',
        process6: 'Déclaration simplifiée de grossesse'
    }
};